import jsbridge from "@kkmh/jsbridge";
import {debug as loging} from "@/assets/js/common/fn/message";
/**
 * Name: hybrid
 * options: {
 *    schema   : 'kkhybrid', //kkhybrid/kkaction
 *    tagname  : 'getSysDeviceInfo',
 *    callback : function
 * }
 */

//hybrid方法
const hybrid = (options) => {
    //requestHybrid时所传递过schema/tagname/param/callback
    var schema      = options.schema || "kkhybrid";
    var tagname     = options.tagname || "";
    var param       = options.param || {};
    var callback    = options.callback || "";

    //requestHybrid_wk 可以在接收is_del_nativecallback/debug
    var is_del_nativecallback = options.is_del_nativecallback === false ? false : true;
    var debug = options.debug === true ? true : false;
    if (/jsbridge_debug=true/.test(location.href)) {
        debug = true;
    }
    /**
     * * jsbridge : 使用@kkmh/jsbridge@1.0.3 : https://wiki.quickcan.com/pages/viewpage.action?pageId=122488334
     * 参数
     * options={
     *    @schema               : 'kkhybrid',               //string-Y: kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname              : 'login_win',              //string-Y: 方法名称
     *    @param                : '{id : 123}',             //object-Y: 参数
     *    @callback             : function(res, nativecallback_name){},     //function-N: 回调函数
     *    @is_del_nativecallback: true,                     //boolean-N: 默认true 删除客户端回调函数 (删除那个随机创建的函数名)
     *    @debug                : false,                    //boolean-N: 默认false 不输出log
     * }
     *
     * 返回:无
     * **/
     
    var obj = {
        schema      : schema,           //string : kkmhhybrid, kkhybrid, kkaction ...
        tagname     : tagname,          //string : 方法名称
        param       : param,            //object : 所传递参数
        callback    : function(res){    //string : native调用js回调函数
            if (typeof res == "string") res = JSON.parse(res);
            loging(`[${tagname}返回]`,JSON.parse(JSON.stringify(res)));
            callback && callback(res);
        },   
        is_del_nativecallback : is_del_nativecallback,
        debug       : debug
    };

    loging(`[${tagname}参数]`,JSON.stringify(obj));
    
    ///////判断浏览器环境，kuaikan-chrome是模拟器////////
    if (!/kuaikan\//.test(navigator.userAgent.toLowerCase()) || /kuaikan-chrome/.test(navigator.userAgent.toLowerCase())) {
        var res = {};
        typeof callback === "function" && callback(res);
    }
    //******* 谷歌浏览器模拟端内执行 *******
    if(/kuaikan\//.test(navigator.userAgent.toLowerCase()) && /kuaikan-simulation$/.test(navigator.userAgent.toLowerCase()) && window.webkit){
        window.webkit.messageHandlers.kkHybridBridge.postMessage(obj);
    }

    jsbridge(obj);
    
};

export default hybrid;



// WEBPACK FOOTER //
// ./src/assets/js/common/hybrid/hybrid_wk.js